import get from 'lodash.get';

const getPartnerBrandedHeader = (rootState) =>
  get(rootState, 'user.partnerData.properties.wsBranding.siteHeader', null);

export default getPartnerBrandedHeader;
